import { isMobile } from '@Constants/LeftDrawer';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';
import { useSeenThingsPresenter } from '../SeenThingsPresenter';
import Icon from '@Components/Common/Icons/Icon';
import OwnableTheme from '@Theme';
import { createMotionComponent } from '@legendapp/motion';
import { Animated } from 'react-native';

const StyledWrapper = styled.Pressable<{
  isHovered?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  cursor: pointer;
  background-color: #000;
  border-radius: 50%;

  position: absolute;
  top: ${isMobile ? 21 : 21}px;
  right: ${isMobile ? 81 : 81}px;

  filter: drop-shadow(rgb(155, 155, 155) 0px 0px 20px);
  z-index: 1000000;
`;

const AnimatedPressable = Animated.createAnimatedComponent(StyledWrapper);
const AnimatedView = createMotionComponent(AnimatedPressable);

const SeenThingCloseButton: FC = () => {
  const { switchModal, visible } = useSeenThingsPresenter();

  return (
    <AnimatedView
      onPress={switchModal}
      animate={{
        backgroundColor: visible.value
          ? OwnableTheme.colors.black
          : OwnableTheme.colors.white,
      }}
    >
      <Icon
        icon='EyeIcon'
        cssColor={
          visible.value ? OwnableTheme.colors.white : OwnableTheme.colors.black
        }
        cssSize={32}
      />
    </AnimatedView>
  );
};

export default observer(SeenThingCloseButton);
